import React , { useState, useContext } from 'react'
import { Link , NavLink, useNavigate } from 'react-router-dom'
import menus from '../../pages/menu'
import DarkMode from './DarkMode'
import './styles.scss'
import logo from '../../assets/images/logo/logo_dark.png'
import { msgReadHelper } from '../../utilities/handyFunctions'
import { Context } from '../../contexts/GlobalContext'

const Header = ({paramShowSearch = false}) => {
    const navigate = useNavigate()

    const { globalState, setAccountMode } = useContext(Context)

    const [menuActive, setMenuActive] = useState(null)
    const [showSearch, setShowSearch] = useState(false || paramShowSearch)

    const handleMenuActive = () => {
        setMenuActive(!menuActive)
    }
    
    const [activeIndex, setActiveIndex] = useState(null)

    const handleDropdown = index => {
        if(index instanceof Number) {
            setActiveIndex(index)
        } else {
            setAccountMode(index)
        }
    }

    const regex = /^(\/search\/).*/

    const searchRequest = (event) => {
        let value = String(event.target.value)
        if(String(window.location.pathname).match(regex)) {
            navigate(`/search/${encodeURIComponent(value)}`, {replace: true, state: { showSearch: showSearch }})
        } else {
            navigate(`/search/${encodeURIComponent(value)}`, {state: { showSearch: showSearch }})
        }
    }

    var willAutoFocus = false
    var value = ''
    if(window.location.pathname.match(regex)) {
        value = String(window.location.pathname).replace('/search/', '')
        value = decodeURIComponent(value)
        willAutoFocus = true        // stops autofocus at search-bar on pages other than search
    }

    var searchReveal = null

    if(showSearch) {
        searchReveal = {
            display: 'flex',
            width: '100%'
        }
    }

    var menuStyle = {paddingLeft: '40px', paddingRight: '20px'}
    if(menuActive) {
        menuStyle = {paddingLeft: '10px', paddingRight: '20px'}
    }

    let unreadMsgs = 0
    if(globalState.threads.length > 0) {
        globalState.threads.map(val => {
            let {unreadMarker, otherParty, lastMsg, lastRead} = msgReadHelper(val, globalState.user._id)
            if(unreadMarker) {
                unreadMsgs += 1
            }
        })
    }

    return (
        <header id="header_main" className="header_1 js-header is-fixed">
        <div className="themes-container">
            <div className="row">
                <div className="col-md-12">
                    <div id="site-header-inner">
                        <div className="wrap-box flex">
                            <div id="site-logo" className="clearfix" >
                                <div id="site-logo-inner">
                                    <NavLink to="/" className="main-logo"><img src={logo} alt="Icoland" style={{width: '150px'}}/></NavLink>
                                </div>
                            </div>
                            <div className={`mobile-button ${menuActive ? 'active' : ''}`} 
                                onClick={handleMenuActive}
                            ><span></span></div>
                            <nav id="main-nav" className={`main-nav ${menuActive ? 'active' : ''}`} style={menuStyle}>
                                <ul id="menu-primary-menu" className="menu">
                                    {
                                        menus.slice(0, 4).map((data,idx) => (
                                            <li key={idx} onClick={()=> handleDropdown(idx)}
                                                className={`menu-item menu-item-addition ${data.namesub ? 'menu-item-has-children' : ''} ${activeIndex === idx ? 'active' : ''}` }
                                            >
                                                <Link to={data.links} style={{fontWeight: 500, fontSize: '14px'}}>{data.name}</Link>
                                                {
                                                    data.namesub &&
                                                    <ul className="sub-menu" style={{padding: '10px', borderRadius: '10px', width: '150px'}}>
                                                        {
                                                            data.namesub.map((submenu) => (
                                                                <li key={submenu.id} className="menu-item submenu-item-addition">
                                                                    <NavLink to={submenu.links} onClick={handleDropdown} style={{fontWeight: 500, fontSize: '14px'}}>
                                                                        {submenu.sub}
                                                                    </NavLink>
                                                                </li>
                                                            ))
                                                        }
                                                    </ul>
                                                }
                                            </li>
                                        ))
                                    }
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <DarkMode unreadMsgCount={unreadMsgs}/>
    </header>
    )
}

export default Header;